module.exports = __webpack_public_path__ + "static/media/monitor-green.41fbc972.svg";